const wording = {
  cancelButtonLabel: 'Annuler',
  confirmButtonLabel: 'Confirmer',
};

export default wording;
